
import React, { useContext } from 'react';
import { CostEstimatorProvider } from '@/context/CostEstimatorContext';
import StepIndicator from './StepIndicator';
import PlatformStep from './PlatformStep';
import AppTypeStep from './AppTypeStep';
import FeaturesStep from './FeaturesStep';
import UserVolumeStep from './UserVolumeStep';
import MaintenanceStep from './MaintenanceStep';
import SummaryStep from './SummaryStep';
import { useCostEstimator } from '@/context/CostEstimatorContext';
import { BaseUrlContext } from './web-components/utils/renderer/contexts';

const steps = [
  'Platforms',
  'App Type',
  'Features',
  'User Volume',
  'Maintenance',
  'Summary'
];

const StepContent: React.FC = () => {
  const { currentStep } = useCostEstimator();
  const baseUrl = useContext(BaseUrlContext);

  // We can use baseUrl here if needed for any resource loading

  switch (currentStep) {
    case 1:
      return <PlatformStep />;
    case 2:
      return <AppTypeStep />;
    case 3:
      return <FeaturesStep />;
    case 4:
      return <UserVolumeStep />;
    case 5:
      return <MaintenanceStep />;
    case 6:
      return <SummaryStep />;
    default:
      return <PlatformStep />;
  }
};

const CostEstimatorContent: React.FC = () => {
  return (
    <div className="max-w-4xl mx-auto px-4 py-8">
      <div className="mb-10">
        <StepIndicator steps={steps} />
      </div>
      <StepContent />
    </div>
  );
};

// Export BaseUrlContext for use in other components
export { BaseUrlContext };

const CostEstimator: React.FC = () => {
  const baseUrl = useContext(BaseUrlContext);
  console.log("CostEstimator received baseUrl:", baseUrl);
  
  return (
    <CostEstimatorProvider totalSteps={6}>
      <CostEstimatorContent />
    </CostEstimatorProvider>
  );
};

export default CostEstimator;
